import { LanguageSelect } from "@/components/language-select";
import { ThemeToggle } from "@/components/theme-toggle";

/**
 * Theme and language, pinned to the bottom-left corner as the legacy screens
 * have them.
 *
 * For the screens that are nothing but a form — sign in, the reset request,
 * setting a password, changing one. Pages that carry the app's own chrome put
 * the same two controls in the header instead, where a floating pair would
 * only sit on top of the sidebar.
 */
export function AppearanceControls() {
  return (
    <footer className="fixed bottom-5 left-5 z-10 flex items-center gap-3 sm:bottom-6 sm:left-8 lg:bottom-8 lg:left-8">
      <ThemeToggle />
      <LanguageSelect />
    </footer>
  );
}
